const accordionHeaders = document.querySelectorAll('[data-accordion-header]');

for (let i = 0; i < accordionHeaders.length; i++) {
    let target = accordionHeaders[i].nextElementSibling;    
    accordionHeaders[i].addEventListener('click', function(e) {
        let expanded = accordionHeaders[i].getAttribute('aria-expanded') === 'true' || false;
            accordionHeaders[i].parentNode.classList.toggle('open');
            accordionHeaders[i].setAttribute('aria-expanded', !expanded);
            target.hidden = expanded;
    })
}